import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// material import
import {
  Box,
  CircularProgress,
  Divider,
  Grid2,
  Typography,
  Zoom,
} from "@mui/material";

// project import
import CheckCircleTwoToneIcon from "@mui/icons-material/CheckCircleTwoTone";
import CustomTable from "../../ui-components/customTable";
import Header2 from "../../ui-components/headerii";
import { formatDateForDisplay } from "../../utils/dateUtils";

const PayLaterConfirmation = () => {
  const [loading, setLoading] = useState(true);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const formatDate = (dateString) => formatDateForDisplay(dateString);

  const columns = [
    { label: "Reservation No", field: "reservation_number" },
    { label: "Donor Name", field: "donor_name" },
    { label: "Package Name", field: "package_name" },
    { label: "Reserved Date", field: "reserved_date" },
    { label: "Total", field: "total" },
    { label: "Payment Method", field: "payment_method" },
  ];

  useEffect(() => {
    const sendPayLaterEmail = async () => {
      setLoading(true);

      if (location.state && location.state.reservationDetails) {
        const reservation = location.state.reservationDetails;

        // The backend now sends the Pay Later payment-instructions email
        // itself, server-side, as part of create-reservation -- it no longer
        // depends on this page successfully making a second call after
        // redirect (which could silently never happen). This page just shows
        // the booking summary using the details already returned by that
        // successful create-reservation call.
        try {
          setPaymentData({
            reservation_number: reservation.reservation_number,
            donor_name: reservation.fullname,
            package_name: reservation.package_title,
            reserved_date: formatDateForDisplay(reservation.date),
            total: `Rs. ${reservation.package_price}`,
            payment_method: `${reservation.payment_type}(${reservation.payment_option})`,
          });
          setPaymentSuccess(true);
        } finally {
          setLoading(false);
        }
      }
    };

    sendPayLaterEmail();
  }, [location.state]);

  return (
    <Box align="center">
      <Header2 />
      <Grid2 container justifyContent="center">
        <Grid2 item size={{ xs: 8.2 }}>
          {loading ? (
            <Box alignContent="center" sx={{ mt: 10, fontSize: 30 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Grid2 item>
              <Box sx={{ mt: 5 }}>
                <CheckCircleTwoToneIcon color="success" sx={{ fontSize: 60 }} />

                <Typography variant="h5" sx={{ fontWeight: "bold", mt: 2 }}>
                  Thank you for your Reservation
                </Typography>

                <Typography
                  variant="body1"
                  sx={{ fontWeight: "medium", mt: 3 }}
                >
                  Thank you for confirming your sponsorship for  Suwa Arana -
                  Place for Healing
                  <br />
                  Your sponsorship and payment details have been successfully
                  recorded, and the payment URL has been sent to you via email.
                  You can use this URL to proceed with the payment. Please check
                  your email for a copy of your invoice and sponsorship
                  information. We will send reminders as your reserved date
                  approaches to help you stay informed.
                  <br />
                  Thank you again for your invaluable support
                </Typography>
              </Box>

              {paymentSuccess && paymentData && (
                <Grid2 item size={{ xs: 12 }}>
                  <Divider
                    variant="middle"
                    sx={{
                      maxWidth: "100%",
                      border: "1px dashed lightgrey",
                      mt: 3,
                      mb: 5,
                    }}
                  />
                  <CustomTable
                    columns={columns}
                    rows={[paymentData]}
                    hideFooter
                  />
                </Grid2>
              )}
              <Box sx={{ mb: 10 }} />
            </Grid2>
          )}
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default PayLaterConfirmation;
